<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-50">
      <staff-list
        v-bind:staff="staffList"
        v-on:addStaff="addStaff"
        v-on:viewStaff="viewStaff"
        v-on:deleteStaff="deleteStaff"
      ></staff-list>
    </div>
    <div class="md-layout-item md-size-50">
      <staff-tabs
        :staff="selectedStaff"
        v-on:staffUpdated="staffUpdated"
      ></staff-tabs>
    </div>
  </div>
</template>

<script>
import staffApi from "@/services/api/staff";
import confirm from "@/helpers/deleteConfirm";

import _filter from "lodash/filter";
import _findIndex from "lodash/findIndex";

import Swal from "sweetalert2";

import StaffList from "./StaffList";
import StaffTabs from "./StaffTabs";

export default {
  components: {
    StaffList,
    StaffTabs
  },

  data() {
    return {
      selectedStaff: null,
      staffList: []
    };
  },

  methods: {
    getStaff() {
      staffApi.getStaff().then(response => {
        this.staffList = response.data;
      });
    },

    addStaff() {
      this.selectedStaff = {};
    },

    viewStaff(staff) {
      this.selectedStaff = { ...staff };
    },

    deleteStaff(staff) {
      confirm.delete(null).then(resp => {
        if (resp.value) {
          staffApi.deleteStaff(staff.id).then(response => {
            this.staffList = _filter(this.staffList, function(r) {
              return r.id !== staff.id;
            });

            this.$notify({
              timeout: 2500,
              message: "Deleted.",
              icon: "cancel",
              horizontalAlign: "center",
              verticalAlign: "top",
              type: "danger"
            });
          });
        }
      });
    },

    staffUpdated(updateInfo) {
      if (updateInfo.mode == "CREATE") {
        this.staffList.unshift(updateInfo.staff);
      } else {
        var index = _findIndex(this.staffList, {
          id: updateInfo.staff.id
        });
        this.staffList.splice(index, 1, updateInfo.staff);
      }

      this.selectedStaff = updateInfo.staff;
    }
  },

  mounted() {
    this.getStaff();
  }
};
</script>
